__turbopack_context__.v({
  "teaserClusterDivider": "ArticleSearchList-module-scss-module__EeOqMG__teaserClusterDivider",
});
